import React from 'react';
import { formatFileSize } from '../utils/formatters';

/**
 * StorageIndicator Component
 * 
 * Displays account-wide storage usage with:
 * - Progress bar visualization
 * - Used/total storage display
 */
const StorageIndicator = ({ storageUsed, storageLimit, storagePercent }) => {
  return (
    <div className="attachments-modal__storage">
      <div className="attachments-modal__storage-header">
        <span className="attachments-modal__storage-label">Account Storage</span>
        <span className="attachments-modal__storage-value">
          {formatFileSize(storageUsed)} / {formatFileSize(storageLimit)}
        </span>
      </div>
      <div className="attachments-modal__storage-bar">
        <div 
          className="attachments-modal__storage-fill"
          style={{ width: `${Math.min(storagePercent, 100)}%` }}
        />
      </div>
    </div>
  );
};

export default StorageIndicator;
